<title mat-dialog-title style="color: brown;"> HATA </title>
<mat-dialog-content style="width: 400px;">
    {{message}}
    <br/>
    <span style="color: cornflowerblue;">Çözüm Önerisi : </span> {{solutionOffer}}
</mat-dialog-content>
<mat-dialog-actions align="end">
<button mat-raised-button color="primary" mat-dialog-close tabindex="-1">{{cancelButtonText}}</button>
</mat-dialog-actions>